import React, { useState } from 'react'
import FormHelperText from '@material-ui/core/FormHelperText'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import Alert from '@material-ui/lab/Alert'
import AlertTitle from '@material-ui/lab/AlertTitle'
import Collapse from '@material-ui/core/Collapse'
import { styled } from '@material-ui/core/styles'
import { Auth } from 'aws-amplify';

const IkeaButton = styled(Button)({
    boxShadow: 'none',
    textTransform: 'none',
    fontSize: 16,
    padding: '16px 6px',
    margin: '16px 0',
    border: '1px solid',
    lineHeight: 1.5,
    backgroundColor: '#0059d6',
    borderColor: '#0059d6',
    fontFamily: ['-apple-system', 'BlinkMacSystemFont', '"Segoe UI"', 'Roboto', '"Helvetica Neue"', 'Arial', 'sans-serif', '"Apple Color Emoji"', '"Segoe UI Emoji"', '"Segoe UI Symbol"'].join(','),
    '&:hover': {
        backgroundColor: '#0059d6',
        borderColor: '#0059d6',
        boxShadow: 'none',
    }
})

async function confirmSignUp(email,code) {
  try {
    await Auth.confirmSignUp(email, code)
  } catch (error) {
    console.log('error confirming sign up', error)
  }
}

const CognitoSignUpForm = () => {

    const [showError, toggleShowError] = useState(false)

    const [showCode, toggleShowCode] = useState(false)

    const [resp, setResp] = useState()

    const [fields, setFields] = useState({
      email: '',
      password: '',
      code: ''
    })

    const onChange = (e) => {
      setFields({
        ...fields,
        [e.target.name]: e.target.value,
      })
    }

    const onSubmit = async (e) => {
        e.preventDefault()
        try {
          const { user } = await Auth.signUp({
            username: fields.email,
            email: fields.email,
            password: fields.password,
            // attributes: {
            //   email, // optional
            //   phone_number, // optional - E.164 number convention
            //   // other custom attributes
            // },
            // autoSignIn: {
            //   // optional - enables auto sign in after user is confirmed
            //   enabled: true,
            // },
          })
          toggleShowCode(!showCode)
          confirmSignUp(fields.email, fields.code)
          console.log(user)
        } catch (error) {
          toggleShowError(!showError)
          console.log('error signing up:', error)
          setResp(error.message)
        }
    }

    return (
      <form onSubmit={onSubmit}>
        <TextField label="Email address" name="email" value={fields.email} onChange={onChange} variant="outlined" fullWidth margin="normal" autoFocus={true} required />

        <TextField label="Password" name="password" value={fields.password} onChange={onChange} variant="outlined" type="password" fullWidth margin="normal" required />

        <Collapse in={showError}>
          <Alert severity="error">
            <AlertTitle>Error</AlertTitle>
            {resp && <>{resp}</>}
          </Alert>
        </Collapse>
        <Collapse in={showCode}>
          <TextField label="Code" name="code" value={fields.code} onChange={onChange} variant="outlined" fullWidth margin="normal" />
          <IkeaButton variant="contained" color="primary" fullWidth={true} size="large" type="submit">
            Verify
          </IkeaButton>
        </Collapse>
        <Collapse in={!showCode}>
          <IkeaButton variant="contained" color="primary" fullWidth={true} size="large" type="submit">
            Sign up
          </IkeaButton>
        </Collapse>
      </form>
    )
}

export default CognitoSignUpForm